import { render, staticRenderFns } from "./DriversEventsAnnotations.vue?vue&type=template&id=ee503b06&scoped=true&"
import script from "./DriversEventsAnnotations.vue?vue&type=script&lang=js&"
export * from "./DriversEventsAnnotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee503b06",
  null
  
)

export default component.exports